<template>
    <div class="match-step">
        <div class="match-step-content">
            <div class="first-row">
                <p class="confirm-email-title">Confirm Your Email</p>
                <p class="confirm-email-descr">
                    Check your email for the confirmation link to activate your account.
                </p>
            </div>
            <div class="second-row">
                <p class="activate-resend-title">Didn't receive an email?</p>
                <div class="steps-to-fix">
                    <p class="step">1. Check your spam folder</p>
                    <p class="step">
                        2. Add <span class="shows-email">shows@hedlyner.com</span> to your
                        address book.
                    </p>
                </div>
                <button @click="resendActivation" class="resend-activate-email-btn">
                    Send a new activation email
                </button>
            </div>
            <div class="third-row">
                <p class="contact-title">Activation link not working?</p>
                <button @click="contactUs" class="contact-us-btn">Contact Us</button>
            </div>
        </div>
        <div class="actions">
            <button @click="toggleClaimProfile(false)" class="cta-btn">Close</button>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import { useArtistClaimProfile } from '@/composables/features/artist-claim-profile/useArtistClaimProfile'

    const URLS = {
        xhr: {
            mutate: {
                resend: '/email/resend'
            }
        },
        redirect: {
            contact: '/contact-us'
        }
    }

    export default {
        name: 'MatchStep',
        setup() {
            const { toggleClaimProfile } = useArtistClaimProfile()
            return {
                toggleClaimProfile
            }
        },
        computed: {
            URLS: () => URLS
        },
        methods: {
            async resendActivation() {
                try {
                    await axios.get(this.URLS.xhr.mutate.resend)
                } catch (error) {
                    console.error(error)
                }
            },
            contactUs() {
                window.open(this.URLS.redirect.contact, '_blank')
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    $mobileMax: 600px;

    @media screen and (max-width: $mobileMax) {
        .match-step-content {
            padding-left: 0px !important;
            padding-right: 0px !important;
            padding-bottom: 40px !important;
            border-bottom: none !important;

            .contact-title,
            .activate-resend-title {
                font-size: 20px !important;
            }
        }
        .actions {
            padding-left: 0px !important;
            padding-right: 0px !important;

            .cta-btn {
                width: 100%;
            }
        }
    }
    button {
        border: none;
    }
    p {
        margin-bottom: 0px;
    }
    .match-step {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .match-step-content {
            padding-left: 56px;
            padding-right: 56px;
            padding-bottom: 28px;
            border-bottom: 1px solid #333333;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 32px;

            .first-row {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;

                .confirm-email-title,
                .confirm-email-descr {
                    color: #cdeb09;
                    @include base-font-16;
                    line-height: 125%;
                }
                .confirm-email-descr {
                    color: #8b8b8b;
                }
            }
            .resend-activate-email-btn,
            .contact-us-btn {
                display: flex;
                padding: 8px 16px;
                align-items: center;
                gap: 4px;
                border-radius: 120px;
                border: 1px solid #cdeb09;
                background: transparent;
                color: #cdeb09;
                @include base-font-14;
                line-height: 115%;
                letter-spacing: 0.14px;
            }

            .second-row {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                gap: 8px;

                .activate-resend-title {
                    color: #dedede;
                    @include base-font-26;
                    line-height: 120%;
                    letter-spacing: -0.52px;
                }
                .steps-to-fix {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;

                    .step,
                    .shows-email {
                        color: #8b8b8b;
                        @include base-font-16;
                        line-height: 125%;
                    }
                    .shows-email {
                        color: #dedede;
                    }
                }
            }
            .third-row {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                gap: 8px;

                .contact-title {
                    color: #dedede;
                    @include base-font-26;
                    line-height: 120%;
                    letter-spacing: -0.52px;
                }
            }
        }
        .actions {
            width: 100%;
            padding: 16px 24px;

            .cta-btn {
                margin-left: auto;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 12px 32px;
                border-radius: 120px;
                background: #cdeb09;
                color: #000;
                @include base-font-18;
                line-height: 133%;
            }
            .cta-btn:disabled {
                opacity: 0.5;
            }
        }
    }
</style>
